import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "lb-form" }
const _hoisted_2 = { key: 9 }
const _hoisted_3 = { key: 10 }
const _hoisted_4 = {
  key: 11,
  class: "lb-form-editor"
}
const _hoisted_5 = {
  key: 12,
  class: "lb-form-permission"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_l_gallery = _resolveComponent("l-gallery")!
  const _component_l_file = _resolveComponent("l-file")!
  const _component_l_editor = _resolveComponent("l-editor")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.show)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          "label-col": { span: _ctx.labelCol }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (i, k) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                (i.name !== 'key')
                  ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                      key: 0,
                      label: i.label,
                      extra: i.extra
                    }, _ctx.validateInfos[i.name]), {
                      default: _withCtx(() => [
                        (i.read === true)
                          ? (_openBlock(), _createBlock(_component_a_typography_text, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.models[i.name]), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (i.type === undefined || i.type === 'input')
                            ? (_openBlock(), _createBlock(_component_a_input, {
                                key: 1,
                                value: _ctx.models[i.name],
                                "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event)
                              }, null, 8, ["value", "onUpdate:value"]))
                            : (i.type === 'password')
                              ? (_openBlock(), _createBlock(_component_a_input_password, {
                                  key: 2,
                                  value: _ctx.models[i.name],
                                  "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event)
                                }, null, 8, ["value", "onUpdate:value"]))
                              : (i.type === 'switch')
                                ? (_openBlock(), _createBlock(_component_a_switch, {
                                    key: 3,
                                    checked: _ctx.models[i.name],
                                    "onUpdate:checked": ($event: any) => ((_ctx.models[i.name]) = $event),
                                    "checked-value": 1,
                                    "un-checked-value": 0
                                  }, null, 8, ["checked", "onUpdate:checked"]))
                                : (i.type === 'radio')
                                  ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                      key: 4,
                                      value: _ctx.models[i.name],
                                      "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event),
                                      options: i.params,
                                      "button-style": "solid"
                                    }, null, 8, ["value", "onUpdate:value", "options"]))
                                  : (i.type === 'select')
                                    ? (_openBlock(), _createBlock(_component_a_select, {
                                        key: 5,
                                        value: _ctx.models[i.name],
                                        "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event),
                                        options: i.params,
                                        "show-search": "",
                                        "option-filter-prop": "label"
                                      }, null, 8, ["value", "onUpdate:value", "options"]))
                                    : (i.type === 'number')
                                      ? (_openBlock(), _createBlock(_component_a_input_number, {
                                          key: 6,
                                          value: _ctx.models[i.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event),
                                          min: i.params.min,
                                          max: i.params.max,
                                          step: i.params.step,
                                          precision: i.params.precision,
                                          style: { width: '100%' }
                                        }, null, 8, ["value", "onUpdate:value", "min", "max", "step", "precision"]))
                                      : (i.type === 'interval')
                                        ? (_openBlock(), _createBlock(_component_a_range_picker, {
                                            key: 7,
                                            value: _ctx.models[i.name],
                                            "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event),
                                            "show-time": { format: _ctx.timeFormat },
                                            format: _ctx.dateFormat,
                                            placeholder: i.placeholder
                                          }, null, 8, ["value", "onUpdate:value", "show-time", "format", "placeholder"]))
                                        : (i.type === 'area')
                                          ? (_openBlock(), _createBlock(_component_a_cascader, {
                                              key: 8,
                                              "change-on-select": "",
                                              "expand-trigger": "hover",
                                              placeholder: i.placeholder ? i.placeholder : '请选择地区',
                                              value: _ctx.models[i.name],
                                              "onUpdate:value": ($event: any) => ((_ctx.models[i.name]) = $event),
                                              options: _ctx.areaOptions,
                                              "show-search": { searchAreaFilter: _ctx.searchAreaFilter },
                                              "field-names": { value: 'code' }
                                            }, null, 8, ["placeholder", "value", "onUpdate:value", "options", "show-search"]))
                                          : (i.type === 'gallery')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                _createVNode(_component_l_gallery, {
                                                  ref_for: true,
                                                  ref: _ctx.fRef,
                                                  number: i.params.number,
                                                  name: i.name,
                                                  item: _ctx.models[i.name]
                                                }, null, 8, ["number", "name", "item"])
                                              ]))
                                            : (i.type === 'file')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                  _createVNode(_component_l_file, {
                                                    ref_for: true,
                                                    ref: _ctx.fRef,
                                                    number: i.params.number,
                                                    name: i.name,
                                                    item: _ctx.models[i.name]
                                                  }, null, 8, ["number", "name", "item"])
                                                ]))
                                              : (i.type === 'editor')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createVNode(_component_l_editor, {
                                                      ref_for: true,
                                                      ref: _ctx.fRef,
                                                      name: i.name,
                                                      content: _ctx.models[i.name]
                                                    }, null, 8, ["name", "content"])
                                                  ]))
                                                : (i.type === 'permission')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                      _createVNode(_component_a_tree, {
                                                        checkedKeys: _ctx.models[i.name],
                                                        "onUpdate:checkedKeys": ($event: any) => ((_ctx.models[i.name]) = $event),
                                                        checkable: "",
                                                        "default-expand-all": "",
                                                        selectable: false,
                                                        "tree-data": i.params
                                                      }, null, 8, ["checkedKeys", "onUpdate:checkedKeys", "tree-data"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1040, ["label", "extra"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(_component_a_form_item, {
              "wrapper-col": { offset: _ctx.labelCol }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (bi, bk) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: bk }, [
                    (bi.type === 'submit')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          onClick: _withModifiers(_ctx.submit, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(bi.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["wrapper-col"])
          ]),
          _: 1
        }, 8, ["label-col"]))
      : _createCommentVNode("", true)
  ]))
}